import { useCountUp, useInViewOnce } from '../lib/motion';
import './Studio.css';

const SERVICES = [
  {
    n: '01',
    t: 'Web & product engineering',
    d: 'Full builds, front to back. Interface, API, database and deployment delivered as one coherent product rather than four handovers between contractors.',
    k: ['React / Next.js', 'Node · Python', 'TypeScript'],
  },
  {
    n: '02',
    t: 'SaaS platforms',
    d: 'Auth, subscriptions, metering, dashboards, admin tooling and the invoicing flow. The parts every SaaS needs and nobody enjoys estimating.',
    k: ['Stripe billing', 'Multi-tenant', 'Role-based access'],
  },
  {
    n: '03',
    t: 'Cloud & DevOps',
    d: 'AWS and GCP infrastructure, containerised deploys, CI/CD, Nginx, hardened Linux, and a monthly look at what the bill is doing.',
    k: ['AWS · GCP', 'Docker · K8s', 'CI/CD'],
  },
  {
    n: '04',
    t: 'Architecture review',
    d: 'A second pair of eyes on a system you already run: bottlenecks, cost leaks, security gaps and a prioritised plan you can hand to any team.',
    k: ['Audits', 'Scaling plans', 'Cost review'],
  },
];

const STATS = [
  { v: 100, suf: '+', l: 'Projects shipped' },
  { v: 3,   suf: '',  l: 'Open-source products' },
  { v: 20,  suf: '+', l: 'Technologies in rotation' },
  { v: 24,  suf: 'h', l: 'Reply window' },
];

function Stat({ v, suf, l, run }) {
  const n = useCountUp(v, run);
  return (
    <div className="st-stat">
      <span className="st-stat-v">
        {Math.round(n)}<i>{suf}</i>
      </span>
      <span className="st-stat-l">{l}</span>
    </div>
  );
}

export default function Studio() {
  const [ref, seen] = useInViewOnce(0.3);

  return (
    <section id="studio" className="band st">
      <div className="shell">

        <div className="st-head">
          <div className="sec-head" data-rv="up">
            <span className="sec-tag"><b>04</b> — The practice</span>
            <h2 className="display-lg">
              <span className="mask-line"><span>One engineer.</span></span>
              <span className="mask-line" style={{ '--ml-d': '110ms' }}><span>One invoice.</span></span>
            </h2>
            <p className="lede">
              <strong>AlgorX Software SRL</strong> is my registered practice in Romania —
              contracts, VAT invoices, NDAs. The person you brief is the person who writes
              the code and answers the pager.
            </p>
          </div>

          <div className="st-wordmark" data-rv="zoom" aria-hidden="true">
            {'ALGORX'.split('').map((c, i) => (
              <span key={`${c}-${i}`} style={{ '--i': i }}>{c}</span>
            ))}
          </div>
        </div>

        {/* ── Stats ───────────────────────────────────────── */}
        <div className="st-stats" ref={ref} data-rv="up">
          {STATS.map((s) => <Stat key={s.l} {...s} run={seen} />)}
        </div>

        {/* ── Services ────────────────────────────────────── */}
        <div className="st-services">
          {SERVICES.map((s, i) => (
            <article
              className="st-service"
              key={s.n}
              data-rv="up"
              style={{ '--rv-d': `${i * 100}ms` }}
            >
              <span className="st-service-n">{s.n}</span>
              <h3 className="st-service-t">{s.t}</h3>
              <p className="st-service-d">{s.d}</p>
              <div className="st-service-k">
                {s.k.map((k) => <span className="tag" key={k}>{k}</span>)}
              </div>
              <span className="st-service-line" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
